var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = theme.moneyFormat;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

document.addEventListener('DOMContentLoaded', function(){
  // Header scripts

  function set_element_height_into_variable(parent_container, element_to_measure, css_var_name) {
    height = $(element_to_measure).outerHeight(true);
    $(parent_container).css(`--${css_var_name}`, height + 'px');
  }

  if($('.ch-announcement-bar-container').length){
    set_element_height_into_variable(':root', '.ch-announcement-bar-container', 'announcement_bar_height');
  }

  set_element_height_into_variable(':root', '.ch-container', 'header_height');

  $(window).on('load', function(){
    set_element_height_into_variable(':root', '.ch-container', 'header_height');
    if($('.ch-announcement-bar-container').length){
      set_element_height_into_variable(':root', '.ch-announcement-bar-container', 'announcement_bar_height');
    }
    $('body').removeClass('not-loaded');
  });

  $(window).on('resize', function(){
    if($('.ch-announcement-bar-container').length){
      set_element_height_into_variable(':root', '.ch-announcement-bar-container', 'announcement_bar_height');
    };
    set_element_height_into_variable(':root', '.ch-container', 'header_height');
  });

  function check_current_scroll_position() {
    current_scroll = $(window).scrollTop();
    if(current_scroll > 0) {
      $('.ch-container').addClass('scrolled');
    } else {
      $('.ch-container').removeClass('scrolled');
    }
  }

  check_current_scroll_position();

  $(window).on('scroll', function(){
    check_current_scroll_position()
  });

  $(document).on('click', '[data-toggle-mobile-menu]', function(){
    $('.mobile-menu-container').toggleClass('opened');
    $('.ch-container').toggleClass('menu-opened');
    $('html').toggleClass('disable-scroll');
  });

  $(document).on('click', '.mobile-menu-container', function(e){
		if(!$(e.target).parents('.mobile-menu-wrapper').length){
			$('.mobile-menu-container').toggleClass('opened');
      $('.ch-container').toggleClass('menu-opened');
			$('html').toggleClass('disable-scroll');
		}
	});

  // Footer scripts
  $(document).on('click', '[data-toggle-collapsible]', function(e) {
    e.preventDefault();
    collapsible_parent_container = $(this).parents('[data-collapsible-container]');
    $(this).toggleClass('opened');
    collapsible_parent_container.find('[data-collapsible-content]').slideToggle();
  });

  // Banner slider
  if ($('.cbs-slider').length){
    $('.cbs-slider').each(function(){
      if ($(this).hasClass('init-slider')){
        var autoplay = $(this).data('autoplay');
        var autoplaySpeed = $(this).data('autoplay-speed');
        $(this).slick({
          dots: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed
        });
      }
    });
  }

  if ($('.ct-slider').length){
    $('.ct-slider').each(function(){
      if ($(this).hasClass('init-slider')){
        $(this).slick({
          dots: true,
          arrows: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    });
  }

  if ($('.ci-ingredients-slider').length){
    $('.ci-ingredients-slider').each(function(){
      var autoplay = $(this).data('autoplay');
      var autoplaySpeed = $(this).data('autoplay-speed');
      var arrows = $(this).data('arrows');
      if ($(this).hasClass('init-slider')){
        $(this).slick({
          dots: false,
          arrows: arrows,
          slidesToShow: 4,
          slidesToScroll: 1,
          speed: 500,
          touchThreshold: 50,
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed,
          responsive: [
            {
              breakpoint: 2000,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 1600,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      }
    });
  }

  // Product details

  if($('.cpt-options-container').length) {
    variant_id = $('.cpt-form-select').val();
    filter_product_options_based_on_variant_id(variant_id);
  }

  /*
  if($('.cpt-subscription-additional-html-container').length) {
    var subscription_interval = setInterval(function() {
      if($('.rc_container').length) {
        $('.rc_widget__option--subsave [data-plans-container]').append($('.cpt-subscription-additional-html-container'));
        var one_time_original_text = $('[data-label-text-onetime]').text();
        $('[data-label-text-onetime]').text(one_time_original_text.substring(0, one_time_original_text.length - 1));
        var subscription_original_text = $('[data-label-text-subsave]').text();
        $('[data-label-text-subsave]').text(subscription_original_text.substring(0, subscription_original_text.length - 1));
        clearInterval(subscription_interval);
      }
    }, 1000);
  }
  */

  function get_variants_with_same_options(option1, option2, option3) {
    product = JSON.parse($('#ProductJson').html());
    available_variants = product.variants.filter(variant => {
      return variant.available == true;
    });

    variants_with_same_options = available_variants.filter(variant => {
      var will_return = false;
      if(variant.option1 && !will_return) {
        will_return = variant.option1 == option1;
      }
      if(variant.option2 && !will_return) {
        will_return = variant.option2 == option2;
      }
      if(variant.option3 && !will_return) {
        will_return = variant.option3 == option3;
      }
      return will_return;
    });

    return variants_with_same_options;
  }

  function filter_product_options_based_on_variant_id(variant_id) {
    product = JSON.parse($('#ProductJson').html());
    current_variant = get_variant_by_id(variant_id, '#ProductJson');

    available_options = {
      option1: [],
      option2: [],
      option3: []
    };

    variants_with_same_options = get_variants_with_same_options(current_variant.option1, current_variant.option2, current_variant.option3);

    for (i = 1; i <= product.options.length; i++) {
      [...variants_with_same_options].forEach(variant => {
        available_options[`option${i}`].push(variant[`option${i}`]);
      });
      // Leaving only unique values
      available_options[`option${i}`] = [...new Set(available_options[`option${i}`])];
    }

    for (i = 1; i <= product.options.length; i++) {
      $(`[data-option-index="option${i}"] .cpt-option`).each(function(){
        value = $(this).data('value');
        if(i > 1) {
          if(available_options[`option${i}`].includes(value)) {
            $(this).prop('disabled', false);
          } else {
            $(this).prop('disabled', true);
          }
        }
      });
    }
  }

  $('.cpt-option').on('click', function(){
  	$(this).addClass('selected').siblings().removeClass('selected');
  	new_value = $(this).data('value');
  	option_container = $(this).parents('.cpt-option-container');
  	option_container.find('.cpt-option-value').html(new_value);
  	option_container.attr('data-current-value', new_value);
  	if (new_value !== 30) update_main_selector();
  });

  $(document).on('change', '.cpt-selling-plan-input', function(){
    plans_container = $(this).parents('.cpt-selling-plans-container');
    selling_plan_input = plans_container.find('[name="selling_plan"]');
    $(this).parents('.cpt-selling-plan-item').addClass('active').siblings('.cpt-selling-plan-item').removeClass('active');
    if($(this).val() == 'subscription') {
      selling_plan_input.val(plans_container.find('[name="selling_plan_value"]').val());
    } else {
      selling_plan_input.val('');
    }
  });

  $(document).on('change', '.cpt-selling-plan-selector', function(){
    plans_container = $(this).parents('.cpt-selling-plans-container');
    selling_plan_input = plans_container.find('[name="selling_plan"]');
    selling_plan_input.val($(this).val());
  });

  function update_main_selector(){
  	option_string = 'option';
  	$('.cpt-option-container').each(function(){
  		option_string += `[data-${$(this).data('option-index')}="${$(this).attr('data-current-value')}"]`;
  	});
  	option = $('.cpt-form-select').find(option_string);
  	if(option.length) {
  		value = option.val();
  		$('.cpt-form-select').val(value);
  		var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + value;
      window.history.replaceState({ path: newUrl }, '', newUrl);
  		update_add_to_cart_button($('.cpt-form-select'));
      filter_product_options_based_on_variant_id(value);
  	} else {
      selected_variant_options = {};
      $('[data-option-index]').each(function(){
        selected_variant_options[`${$(this).attr('data-option-index')}`] = $(this).attr('data-current-value');
      });

      variants_with_same_options = get_variants_with_same_options(selected_variant_options.option1, selected_variant_options.option2, selected_variant_options.option3);

      similar_variants_by_option1 = variants_with_same_options.filter(variant => {
        return variant.option1 == selected_variant_options.option1;
      });

      if(similar_variants_by_option1.length) {
        first_similar_variant = similar_variants_by_option1[0];
        if(first_similar_variant.option2) {
          $(`[data-value="${first_similar_variant.option2}"]`).click();
        }

        if(first_similar_variant.option2) {
          $(`[data-value="${first_similar_variant.option3}"]`).click();
        }

      } else {
        $('.cpt-submit-button').addClass('unavailable');
    		$('.cpt-submit-button').prop('disabled', true);
    		$('.cpt-sb-text').html("Unavailable");
      }
  	}
  }

  function update_add_to_cart_button(selector) {
  	variantId = selector.val();
  	variant = get_variant_by_id(variantId, '#ProductJson');
  	$('.cpt-submit-button').removeClass('unavailable');
    $('[data-variant-price]').html(Shopify.formatMoney(variant.price));

    if(variant.compare_at_price && variant.compare_at_price > variant.price) {
      $('[data-variant-compare-at-price]').show().html(Shopify.formatMoney(variant.compare_at_price));
    } else {
      $('[data-variant-compare-at-price]').hide();
    }

  	if(variant.available) {
  		
  		$('.cpt-sb-text').html("Add to cart");
  
      
      $('.cpt-submit-button').prop('disabled', false);
  		
  	} else {
  		$('.cpt-submit-button').prop('disabled', true);
  		$('.cpt-sb-text').html("Sold out");
  	}

    if(variant.selling_plan_allocations.length) {
      selling_plan = variant.selling_plan_allocations[0];
      $('[data-variant-selling-plan-price]').html(Shopify.formatMoney(selling_plan.price));
      if(selling_plan.compare_at_price && selling_plan.compare_at_price > selling_plan.price) {
        $('[data-variant-selling-plan-compare-at-price]').show().html(Shopify.formatMoney(selling_plan.compare_at_price));
      } else {
        $('[data-variant-selling-plan-compare-at-price]').hide();
      }
    }

    if(variant.featured_media) {
      media_id = variant.featured_media.id;
      media_alt = variant.featured_media.alt || product.title;
      $('[data-thumbnail]').addClass('hidden');
      $(`[data-thumbnail-media-alt="${media_alt}"]`).removeClass('hidden');
  		thumbnail = $(`[data-thumbnail-media-id='${media_id}']`);
  		if(thumbnail.length) {
  			thumbnail.addClass('active').siblings().removeClass('active');
        filter_main_images_slides(media_alt, $('.cpt-main-images-wrapper').slick('getSlick'));
        slide_index = $(`[data-main-media-id="${media_id}"]`).index();
        $('.cpt-main-images-wrapper').slick('slickGoTo', slide_index);
  		}
    }

  }

  function get_variant_by_id(variant_id, product_json_id) {
    var product = JSON.parse($(`${product_json_id}`).html());
    var result = product.variants.filter(obj => {
      return obj.id == variant_id;
    });
    var variant = result[0];
    return variant;
  }

  function filter_main_images_slides(media_alt, slick) {
    slick.unfilterSlides();
    slick.filterSlides(`[data-media-alt="${media_alt}"]`);
    width  = 100 / slick.slideCount + '%';
		progress = (100 / slick.slideCount) * (slick.currentSlide + slick.options.slidesToShow) + '%';
    if(variant.featured_media) {
      if(!slick.$slider.attr('data-select-first-on-load')) {
        selected_slide_index = parseInt($(`[data-main-media-id="${variant.featured_media.id}"]`).data('slick-index'));
        slick.goTo(selected_slide_index);
      }
      slick.$slider.removeAttr('data-select-first-on-load');
    }
		$('.cpt-main-images-progress-bar').css({"--progress": progress, "--width": width});
  }


  $('.cpt-main-images-wrapper').on('init', function(event, slick){
    if($('.cpt-form-select').length) {
      variant_id = $('.cpt-form-select').val();
      variant = get_variant_by_id(variant_id, '#ProductJson');
      if(variant.featured_media) {
        media_alt = variant.featured_media.alt || product.title;
      } else {
        media_alt = product.title;
      }
      filter_main_images_slides(media_alt, slick, variant);
    } else {
      width  = 100 / slick.slideCount + '%';
      progress = (100 / slick.slideCount) * (slick.currentSlide + slick.options.slidesToShow) + '%';
      $('.cpt-main-images-progress-bar').css({"--progress": progress, "--width": width});
    }
	});

  $('.cpt-main-images-wrapper').slick({
		infinite: false,
		dots: true,
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1,
    adaptiveHeight: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          dots: false
        }
      }
    ]
	});

  $('.cpt-main-images-wrapper').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    width  = 100 / slick.slideCount + '%';
		progress = (100 / slick.slideCount) * (nextSlide + 1) + '%';
		$('.cpt-main-images-progress-bar').css({"--progress": progress, "--width": width});
    media_id = $(slick.$slides[nextSlide]).data('main-media-id');
		$(`[data-thumbnail-media-id="${media_id}"]`).addClass('active').siblings().removeClass('active');
	});

	$('[data-thumbnail-media-id]').on('click', function(){
		$(this).addClass('active').siblings().removeClass('active');
    media_id = $(this).data('thumbnail-media-id');
    slide_index = $(`[data-main-media-id="${media_id}"]`).index();
    $('.cpt-main-images-wrapper').slick('slickGoTo', slide_index);
	});

  $(document).on('click', '[data-toggle-popup]', function(e){
    e.preventDefault();
    popup = $(`[data-popup="${$(this).data('toggle-popup')}"]`);
    popup.fadeToggle().toggleClass('opened');
    $('html').toggleClass('disable-scroll');
  });

  $(document).on('click', '.cpt-popup-container', function(e){
		if(!$(e.target).parents('.cpt-popup-content').length){
			$('.cpt-popup-container').fadeToggle().toggleClass('opened');
			$('html').toggleClass('disable-scroll');
		}
	});


  // FAQ Page
  if ($('.custom-faq-page-faq-section').length){
    $(document).on('click','.fp-cpi-block', function(){
      category = $(this).data('category');
      $('.fp-cpi-block').removeClass('active');
      $('.fp-cpf-container').removeClass('visible');
      $(this).addClass('active');
      $('.fp-cpf-container[data-category="'+ category +'"]').addClass('visible');
      $('html,body').animate({
        scrollTop: $('.fp-cpf-container[data-category="'+ category +'"]').offset().top - $('.custom-header-section').outerHeight(true)
      }, 'slow');
    });
  }

  // Buttons
  $(document).on('click', '.custom-button', function(e){
    href = $(this).attr('href');
    if (href && href.includes('#')){
      e.preventDefault();
      $('html,body').animate({
        scrollTop: $(href).offset().top - $('.custom-header-section').outerHeight(true)
      }, 'slow');
    }
  });

  $(document).on('click', '[data-change-quantity]', function(e) {
    e.preventDefault();
    quantity_change = parseInt($(this).data('change-quantity'));
    quantity_input = $(this).parents('form').find('[name="quantity"]');
    if(!quantity_input.length) {
      quantity_input = $(this).parent().find('[name="updates[]"]');
    }
    current_quantity = parseInt(quantity_input.val());
    new_quantity = current_quantity + quantity_change;
    if(new_quantity > 0) {
      quantity_input.val(new_quantity).trigger('change');
      $(this).parent().find('[data-current-quantity]').html(new_quantity);
    }
  });

  // Text with slider
  if ($('.cptwls-slider').length){
    $('.cptwls-slider').each(function(){
      if ($(this).hasClass('init-slider')){
        var autoplay = $(this).data('autoplay');
        var autoplaySpeed = $(this).data('autoplay-speed');
        $(this).slick({
          dots: false,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "90px",
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed,
          mobileFirst: true,
          infinite: true,
          responsive: [
            {
               breakpoint: 767,
               settings: {
                 slidesToShow: 3,
                 slidesToSroll: 1,
                 centerPadding:"0px",
                 centerMode: true
               }
            }
          ]
        });

        $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
          if (currentSlide != nextSlide){
            test_slider = $(this).parent().find('.cptwls-text-slider');
            test_slider.find('.cptwls-text').hide();
            test_slider.find('.cptwls-text[data-block-id="'+ nextSlide +'"]').fadeIn(500);
          }
        });
      }
    });
  }

  // Product upsell
  $(document).on('click','.cpt-upsell-option', function(){
  	$(this).addClass('selected').siblings().removeClass('selected');
  	new_value = $(this).data('upsell-value');
  	option_container = $(this).parents('.cpt-upsell-option-container');
  	option_container.attr('data-current-value', new_value);
    upsell_container = $(this).parents('[data-upsell-container]');
  	update_upsell_main_selector(upsell_container);
  });

  function update_upsell_main_selector(upsell_container){
  	option_string = 'option';
    upsell_product_json_id = '#' + upsell_container.find('[data-upsell-product-json]')[0].id;
  	upsell_container.find('.cpt-upsell-option-container').each(function(){
  		option_string += `[data-${$(this).data('upsell-option-index')}="${$(this).attr('data-current-value')}"]`;
  	});
  	option = upsell_container.find('.cpt-upsell-form-select').find(option_string);
  	if(option.length) {
  		value = option.val();
  		upsell_container.find('.cpt-upsell-form-select').val(value);
      variant = get_variant_by_id(value, upsell_product_json_id);
      if(variant.featured_media) {
        media_id = variant.featured_media.id;
        upsell_container.find(`[data-upsell-media-id="${media_id}"]`).fadeIn().siblings().hide();
      }
      upsell_container.find('[data-upsell-submit]').removeClass('unavailable');
      upsell_container.find('[data-upsell-variant-price]').html(Shopify.formatMoney(variant.price));
      if(variant.compare_at_price && variant.compare_at_price > variant.price) {
        upsell_container.find('[data-upsell-variant-compare-at-price]').show().html(Shopify.formatMoney(variant.compare_at_price));
      } else {
        upsell_container.find('[data-upsell-variant-compare-at-price]').hide();
      }
    	if(variant.available) {
    		upsell_container.find('[data-upsell-submit]').prop('disabled', false);
    		upsell_container.find('[data-upsell-submit-text]').html(theme.strings.upsell.addToCart);
    	} else {
    		upsell_container.find('[data-upsell-submit]').prop('disabled', true);
    		upsell_container.find('[data-upsell-submit-text]').html(theme.strings.upsell.soldOut);
    	}
  	} else {
      selected_variant_options = {};
      upsell_container.find('[data-upsell-option-index]').each(function(){
        selected_variant_options[`${$(this).attr('data-upsell-option-index')}`] = $(this).attr('data-current-value');
      });

      variants_with_same_options = get_variants_with_same_options(selected_variant_options.option1, selected_variant_options.option2, selected_variant_options.option3, upsell_product_json_id);

      similar_variants_by_option1 = variants_with_same_options.filter(variant => {
        return variant.option1 == selected_variant_options.option1;
      });

      if(similar_variants_by_option1.length) {
        first_similar_variant = similar_variants_by_option1[0];
        if(first_similar_variant.option2) {
          upsell_container.find(`[data-upsell-value="${first_similar_variant.option2}"]`).click();
        }

        if(first_similar_variant.option2) {
          upsell_container.find(`[data-upsell-value="${first_similar_variant.option3}"]`).click();
        }

      }
  	}
  }

  // AJAX cart

  if($('#shopify-section-custom-cart-drawer').length) {
    $(document).on('submit', '[data-enable-cart-drawer="true"] form[action="/cart/add"]', function(e) {
      e.preventDefault();
      addItemToCart(this);
    });

    $(document).on('click', '[data-toggle-cart-drawer]', function(e) {
      e.preventDefault();
      $('html').toggleClass('disable-scroll cart-drawer-opened');
    });

    $(document).on('click', '[data-remove-item]', function(e) {
      e.preventDefault();
      item_key = $(this).data('remove-item');
      updateCartItem(item_key, 0);
    });

    $(document).on('change', '[data-change-item-quantity]', function(e) {
      quantity = $(this).val();
      item_key = $(this).data('change-item-quantity');
      updateCartItem(item_key, quantity);
    });

    function updateCartItem(key, quantity) {
      fetch(theme.cartRoutes.cartChangeUrl + '.js',{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;'
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity
        })
      })
      .then(function(response){
        return response.json();
      })
      .then(function(json) {
        if (json.status && json.status !== 200) {
          var error = new Error(json.description);
          error.isFromServer = true;
          throw error;
        }
        renderCartDrawer();
      })
      .catch(function(error) {
        // eslint-disable-next-line no-console
        console.log(error);
      });
    }

    function addItemToCart(form) {
      let productData;
      const validateShipProtection = sessionStorage.getItem('sp');
      const addedProduct = theme.Helpers.serialize(form)
      const addedProductObject = parseUrlParamsToObject(addedProduct);
      
      if (!$(".shipping-protection").length && !validateShipProtection) {
          productData = JSON.stringify({'items': [addedProductObject, {'id': 47527008862489, 'quantity': 1}]})
          sessionStorage.setItem('sp', 'removed');
      } else {
        productData = JSON.stringify({'items': [addedProductObject]})
      }

      fetch(theme.cartRoutes.cartAddUrl + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: productData
      })
        .then(function(response) {
          return response.json();
        })
        .then(function(json) {
          if (json.status && json.status !== 200) {
            var error = new Error(json.description);
            error.isFromServer = true;
            throw error;
          }
          openCartDrawer();
          renderCartDrawer();
        })
        .catch(function(error) {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    }

    function openCartDrawer() {
      $('html').addClass('disable-scroll cart-drawer-opened');
    }

    function renderCartDrawer() {
      var time = Date.now();
      fetch(`/?section_id=custom-cart-drawer&timestamp=${time}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function(response) {
        return response.text();
      }).then(function(text) {
        text_to_html = $.parseHTML(text.replaceAll('\x3C!-- BEGIN static -->','').replaceAll('\x3C!-- END static -->',''));
        section_content = $(text_to_html).html();
        $('#shopify-section-custom-cart-drawer').html(section_content);
        new_cart_count = parseInt($('#shopify-section-custom-cart-drawer [data-current-cart-count]').data('current-cart-count'));
        if(new_cart_count > 0) {
          $('.ch-cart-link').addClass('not-empty');
          var productId = "8966285197593";
          var productElement = document.querySelector('.ccds-item[data-product-id="' + productId + '"]');

          var cartItemsContainer = document.querySelector('.ccds-items-wrapper');
          cartItemsContainer.appendChild(productElement);
        } else {
          $('.ch-cart-link').removeClass('not-empty');
        }
        $('[data-cart-count]').html(new_cart_count);
      });
    }

    function parseUrlParamsToObject(urlParamsString) {
      const paramsArray = urlParamsString.split("&");
      const paramsObject = {};

      paramsArray.forEach(param => {
        const [key, value] = param.split("=");
        paramsObject[key] = decodeURIComponent(value);
      });

      return paramsObject;
    }
  }
  var discount = $(".cpt-selling-plan-discount");
  if (discount.length) {
    const rounded = Math.round(parseFloat(discount.text())) + "%";
    discount.html(rounded);
  }

});
// note(SL): science page javascript code

function sciencePagePrimeTestSection(){
  document.querySelector('.science-page-prime-test-section').classList.add('clickedSection');
  document.querySelector('.science-page-prime-test-section').classList.remove('hideSection')
  document.querySelector('.science-page-prime-test-pro-section').classList.remove('clickedSection');
  document.querySelector('.science-page-prime-test-pro-section').classList.add('hideSection');
  document.querySelector('.science-page-tribulus-section').classList.remove('clickedSection');
  document.querySelector('.science-page-tribulus-section').classList.add('hideSection');
  document.querySelector('.sciencePagePrimeTestSectionTitle p').classList.add('active_science_page_title');
  document.querySelector('.sciencePagePrimeTestProSectionTitle p').classList.add('inactive_science_page_title');
  document.querySelector('.sciencePagePrimeTestProSectionTitle p').classList.remove('active_science_page_title');
  document.querySelector('.sciencePageTribulusTerrestrisExtractTitle p').classList.add('inactive_science_page_title');
  document.querySelector('.sciencePageTribulusTerrestrisExtractTitle p').classList.remove('active_science_page_title');

}
function sciencePagePrimeTestProSection(){
  document.querySelector('.science-page-prime-test-pro-section').classList.add('clickedSection');
  document.querySelector('.science-page-prime-test-pro-section').classList.remove('hideSection');
  document.querySelector('.science-page-prime-test-section').classList.remove('clickedSection');
  document.querySelector('.science-page-prime-test-section').classList.add('hideSection');
  document.querySelector('.science-page-tribulus-section').classList.remove('clickedSection');
  document.querySelector('.science-page-tribulus-section').classList.add('hideSection');
  document.querySelector('.sciencePagePrimeTestSectionTitle p').classList.add('inactive_science_page_title');
  document.querySelector('.sciencePagePrimeTestSectionTitle p').classList.remove('active_science_page_title');
  document.querySelector('.sciencePagePrimeTestProSectionTitle p').classList.add('active_science_page_title');
  document.querySelector('.sciencePageTribulusTerrestrisExtractTitle p').classList.add('inactive_science_page_title');
  document.querySelector('.sciencePageTribulusTerrestrisExtractTitle p').classList.remove('active_science_page_title');
}
function sciencePageTribulusTerrestrisExtract(){
  document.querySelector('.science-page-tribulus-section').classList.add('clickedSection');
  document.querySelector('.science-page-tribulus-section').classList.remove('hideSection')
  document.querySelector('.science-page-prime-test-pro-section').classList.remove('clickedSection');
  document.querySelector('.science-page-prime-test-pro-section').classList.add('hideSection');
  document.querySelector('.science-page-prime-test-section').classList.remove('clickedSection');
  document.querySelector('.science-page-prime-test-section').classList.add('hideSection');
  document.querySelector('.sciencePagePrimeTestSectionTitle p').classList.add('inactive_science_page_title');
  document.querySelector('.sciencePagePrimeTestSectionTitle p').classList.remove('active_science_page_title');
  document.querySelector('.sciencePagePrimeTestProSectionTitle p').classList.add('inactive_science_page_title');
  document.querySelector('.sciencePagePrimeTestProSectionTitle p').classList.remove('active_science_page_title');
  document.querySelector('.sciencePageTribulusTerrestrisExtractTitle p').classList.add('active_science_page_title');
}

$('#toggle-description').on('click', function () {
  $(this).text() === 'Show More' ? $(this).text('Show Less') : $(this).text('Show More');
  $('.cpt-description-container').toggleClass('expanded')
});

$('.cpt-quantity-add').click(function () {		
  var selectedInput = $(this).prev('input');		
  if (selectedInput.val() < 10) {		
    selectedInput[0].stepUp(1);
  }	
});
  
$('.cpt-quantity-sub').click(function () {		
  var selectedInput = $(this).next('input');		
  if (selectedInput.val() > 0) {
    selectedInput[0].stepDown(1);
  }	
});

$(document).ready(function() {
  $('.cpt-thumbnails-container').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    dots: true,
    infinite: true,
    centerMode: true,
    responsive: [
          {
            breakpoint: 654,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          }
        ]
  });
});

$(document).ready(() => {
  $(".search-btn-trigger").click(() => {
    toggleNavMenu()
    $('#search-input').focus();
    $('#overlay').css('display', 'block');
  });

  $("#close-btn").click(() => {
    $('#search-input').val("");
    document.querySelector('#predictive-search').style.display = 'none';
    toggleNavMenu()
    $('#overlay').css('display', 'none');
  });


  function toggleNavMenu() {
    if ($("#search-form").hasClass("active")) {
      $("#search-form").removeClass("active");
    } else {
      $("#search-form").addClass("active");
    }
  }

});

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product,article&resources[limit]=3&section_id=predictive-search`)
            .then((response) => {
              console.log(response, 'response')
              if (!response.ok) {
                var error = new Error(response.status);
                console.log('error----', error)
                this.close();
                throw error;
              }

              return response.text();
            })
            .then((text) => {
              console.log('text', text)
              const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
              this.predictiveSearchResults.innerHTML = resultsMarkup;
              this.open();
            })
            .catch((error) => {
              console.log('error', error)
              this.close();
              throw error;
            });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    this.predictiveSearchResults.style.border = 'solid 1px #000';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.predictiveSearchResults.style.border = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
